import Modal from 'LuxKit/Modal/Modal'
import React from 'react'
import { useIntl } from 'react-intl'
import CFMRUnforseenEventsModalContent from './CFMRUnforseenEventsModalContent'

interface Props {
  quote?: App.InsuranceQuote
}

function CFMRUnforseenEventsModal({ quote }: Props) {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'BZYBft5glU',
    defaultMessage: 'Cancellation policy',
    description: 'Title for the unforeseen events cancellation policy modal',
  })

  const subtitle = intl.formatMessage({
    id: 'cfM574oiyl',
    defaultMessage: 'This exclusive protection from Luxury Escapes and XCover ensures a hassle-free 100% refund if you need to cancel for unforeseen events.',
    description: 'Subtitle explaining the cancellation protection coverage from Luxury Escapes and XCover',
  })

  return <Modal
    title={title}
    subtitle={subtitle}
  >
    <CFMRUnforseenEventsModalContent quote={quote} />
  </Modal>
}

export default CFMRUnforseenEventsModal
